import { render, staticRenderFns } from "./HeaderTag.vue?vue&type=template&id=24695b29&scoped=true&"
import script from "./HeaderTag.vue?vue&type=script&lang=js&"
export * from "./HeaderTag.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTag.vue?vue&type=style&index=0&id=24695b29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24695b29",
  null
  
)

export default component.exports